import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';

import moment from 'moment';
import queryString from 'querystring';

import FlightTable from './FlightTable'
import FlightMobile from './FlightMobile'
// import Headers from './Headers'
// import Flight from './Flight';

import store from './store'
import {actions} from './actions'
import Filters from './Filters';
import {connect} from 'react-redux'


const classes = theme => ({
  container: {
    flexGrow: 1,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8
  },
  item: {},
  inputContainer: {},
  buttonContainer: {
    textAlign: 'center'
  },
  input: {
    marginTop: 8
  },
  button: {
    margin: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  show: {
    display: 'block',
    width: 'auto',
    margin: '0px'
  },
  hide: {
    display: 'none',
    width: 'auto',
    margin: '0px'
  },
  results: {
    background: 'white',
    padding: '4px 8px'
  }
});

class FlightStatus extends Component {
  constructor(props) {
    super();

    const query = queryString.parse(props.location.search.substr(1));

    this.state = {
      flightNumber: ``,
      flightMoment: moment(),
      airlineName: query.airlineName,
      results: [],
      searched: false,
      searching: false,
      error: false
    };
  }

  flightNumberChange(ev) {
    this.setState({
      flightNumber: ev.target.value
    });
  }

  flightDateChange(ev) {
    this.setState({
      flightMoment: moment(ev.target.value)
    });
  }

  checkFlightStatus() {
    const { flightMoment, flightNumber, airlineName } = this.state;
    const url = process.env.REACT_APP_WIDGET_API;
    const data = {
      flightDate: flightMoment.format(`DDMMM`),
      flightNumber,
      airlineName
    };

    this.setState({ searching: true });
    console.log(url,"FLIGHT STATUS URL")
    axios.post(`${url}/flightStatus`, data)
      .then((res) => {
        this.setState({
          results: res.data,
          searched: true,
          searching: false,
          error: false
        });
        store.dispatch(actions.flights(res.data))

      })
      .catch((err) => {
        this.setState({
          error: err,
          searched: true,
          searching: false,
          results: []
        });
      });
  }

  

  render() {
    const { classes, flights, originFilter, destinFilter, flightFilter } = this.props;
    const { flightMoment, flightNumber, searching, searched, results, error } = this.state;
    
    let filteredFlights = flights
                .filter((flight) => flight.depart.airport.startsWith(originFilter))
                .filter((flight) => flight.arrive.airport.startsWith(destinFilter))
                .filter((flight) => flight.flightNumber.startsWith(flightFilter))


    let width = window.innerWidth;


    return (
      <Grid container className={classes.container} spacing={0}>
        <Grid item className={classes.inputContainer} xs={12}>
          <TextField
            id="flightDate"
            label="Flight Date"
            className={classes.input}
            type="date"
            value={flightMoment.format('YYYY-MM-DD')}
            onChange={this.flightDateChange.bind(this)}
            margin="normal"
            fullWidth
            helperText="Choose the date of travel and click Check Status to see all flights"
            variant="outlined"
            disabled={searching}
          />
        </Grid>
        <Grid item className={classes.buttonContainer} xs={12}>
          <Button
            variant="contained"
            color="default"
            className={classes.button}
            onClick={this.checkFlightStatus.bind(this)}
            disabled={searching}
          >
            Check Status
            <Icon className={classes.rightIcon}>search</Icon>
          </Button>
        </Grid>
        <Grid item className={classes.item} xs={12}>
          <LinearProgress className={(searching) ? classes.show : classes.hide} />
        </Grid>
        <Grid item xs={12}>
          <Filters/>
        </Grid>
        <Grid item className={classes.results} xs={12}>
          <div className={(searched) ? classes.show : classes.hide} >
            {(error) ? <h3>{error.message}</h3> : ''}
            {(!error && results.length === 0) ? <h3>No flights found!</h3> : ''}
            {/* <Headers/> */}
            {width > 725 ? <FlightTable flights={filteredFlights}/> : <FlightMobile flights={filteredFlights}/>}
            {/* {filteredFlights.map((flight, i) => (
              <Flight key={i} flight={flight} index={i}/>
            ))} */}
          </div>
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    flights: state.flights,
    originFilter: state.originFilter,
    destinFilter: state.destinFilter,
    flightFilter: state.flightNumFilter
  }
}

FlightStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object,
  flights: PropTypes.array,
  originFilter: PropTypes.string,
  destinFilter: PropTypes.string,
  flightFilter: PropTypes.string
};

const connectToStore = connect(mapStateToProps)
const ConnectedComponent = connectToStore(FlightStatus)

export default withStyles(classes)(ConnectedComponent);



// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/index.js